import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
// import BackToHomeButton from 'src/components/BackToHomeButton.js'
import { DocumentViewer } from 'src/components/GlobalModals/DocumentViewer.js'
import DownloadModal from 'src/components/GlobalModals/DownloadModal.js'
import IframeModal from 'src/components/GlobalModals/IframeModal.js'
import PosterModal from 'src/components/GlobalModals/PosterModal.js'
import VideoModal from 'src/components/GlobalModals/VideoModal.js'
import { fixedAssets } from 'src/containers/PreCache.js'
import styled from 'styled-components'
import LoadIcon from '../components/LoadIcon.js'
import { getBooth, getBooths } from '../ducks/booth'
import Amplitude from '../utils/amplitudeHelper'
import { boothKV } from './BoothPage.js'
import pdf from '../images/mobile/pdf.png'
import play from '../images/mobile/play.png'
import message from '../images/mobile/message.png'
import TawkModal from 'src/components/GlobalModals/TawkModal'
import { loadTawk } from '../utils/tawkToHelper'

const EMBED_DIV_ID = 'TAWK_EMBED'

const MobileBooth = ({ currentUser }) => {
  const history = useHistory()
  const { boothId } = useParams()
  const dispatch = useDispatch()
  const { viewBooth, booths } = useSelector((state) => state.booth)

  const [iframeOpen, setIframeOpen] = useState(false)
  const [posterOpen, setPosterOpen] = useState(false)
  const [downloadOpen, setDownloadOpen] = useState(false)
  const [videoOpen, setVideoOpen] = useState(false)
  const [playVideo, setPlayVideo] = useState({})
  const [documentSelected, setDocumentSelected] = useState(null)
  const [tawkOpen, setTawkOpen] = useState(false)
  const [isCustom, setIsCustom] = useState(false)

  useEffect(() => {
    dispatch(getBooth(boothId))
  }, [boothId, dispatch])

  useEffect(() => {
    if (viewBooth && viewBooth.id == boothId) {
      dispatch(getBooths(viewBooth.hall.id))
      Amplitude.visitBooth(viewBooth.title)
    }
  }, [boothId, currentUser.id, dispatch, viewBooth])

  const handleModal = (video) => {
    Amplitude.watchBoothVideo(video.filename)
    setPlayVideo(video)
    setIframeOpen(true)
    setVideoOpen(false)
  }

  const handleDownload = () => {
    Amplitude.clickHotButtons(viewBooth.title, 'pdf')
    setDownloadOpen(!downloadOpen)
  }

  const handleVideoModal = (type="") => {
    setIsCustom(type === 'custom' ? true : false)
    Amplitude.clickHotButtons(viewBooth.title, 'video')
    setVideoOpen(!videoOpen)
  }
  const handlePoster = (type) => {
    Amplitude.clickHotButtons(viewBooth.title, type)
    setPosterOpen(!posterOpen)
  }
  const openTawk = () => {
    if (viewBooth) {
      Amplitude.clickHotButtons(viewBooth.title, 'chat')
      const { chat_link } = viewBooth
      loadTawk(currentUser, chat_link, EMBED_DIV_ID)
      setTawkOpen(!tawkOpen)
    }
  }
  const goNext = () => {
    const navigateTo = booths.filter(booth=>booth.order===viewBooth.order+1)[0].id
    const nextLink = `/booths/${navigateTo}`
    history.push(nextLink)
  }

  const goPrevious = () => {
    const navigateTo = booths.filter(booth=>booth.order===viewBooth.order-1)[0].id
    const prevLink = `/booths/${navigateTo}`
    history.push(prevLink)
  }

  if (!viewBooth) {
    return (
      <Page>
        <LoadIcon />
      </Page>
    )
  }
  return (
    <Page>
      <div className="outer-wrapper">
        <div className='navCon py-3'>
          <div className="container">
            <div className="nav-wrapper">
              <p className="booth-name">{viewBooth.title}</p>
              <div className="nav-buttons-wrapper">
                {viewBooth.order !== 0 && (
                  <svg width="17.301" height="26.839" viewBox="0 0 17.301 26.839" className="nav-button-icon" onClick={goPrevious}>
                    <g transform="translate(17.301 26.839) rotate(180)">
                      <path d="M.459,14.462,13.147,26.407a1.637,1.637,0,0,0,2.216,0l1.48-1.393a1.415,1.415,0,0,0,0-2.084L6.79,13.419,16.845,3.909a1.415,1.415,0,0,0,0-2.084L15.363.432a1.637,1.637,0,0,0-2.216,0L.459,12.376A1.415,1.415,0,0,0,.459,14.462Z" transform="translate(17.301 26.839) rotate(180)" fill="#fff"/>
                    </g>
                  </svg>
                )}
                {viewBooth.order !== booths.length-1 && (
                  <svg width="17.301" height="26.839" viewBox="0 0 17.301 26.839" className="nav-button-icon" onClick={goNext}>
                    <path d="M.459,12.376,13.147.432a1.637,1.637,0,0,1,2.216,0l1.48,1.393a1.415,1.415,0,0,1,0,2.084L6.79,13.419,16.845,22.93a1.415,1.415,0,0,1,0,2.084l-1.48,1.393a1.637,1.637,0,0,1-2.216,0L.459,14.462A1.415,1.415,0,0,1,.459,12.376Z" transform="translate(17.301 26.839) rotate(180)" fill="#fff"/>
                  </svg>
                )}
              </div>
              
            </div>
          </div>
        </div>

        <div className="booth-image-wrapper">
          <img id="boothKv" src={boothKV[boothId == 35 ? 2 : boothId-1]} alt="booth visual" />

          <img src={fixedAssets.boothBase} className="booth-base" alt="booth"/>
          <img src={viewBooth.background_image.url} className="booth-image" alt="booth"/>
        </div>

        <div className='booth-material-container'>
          {viewBooth ? (
            <div className="container pt-3 p-0">
              <div className='divider' />
              <div className="booth-menu-list">
                {viewBooth.id === 1 &&
                  <div className="booth-menu-item" onClick={() => handleVideoModal("custom")}>
                    <img src={play} className="booth-menu-item-icon" alt="video-icon"/>
                    <p className="booth-menu-item-label">Video Gallery</p>
                  </div>
                }
                {viewBooth.booth_videos.length > 0 && 
                  <div className="booth-menu-item" onClick={() => handleVideoModal("normal")}>
                    <img src={play} className="booth-menu-item-icon" alt="video-icon"/>
                    <p className="booth-menu-item-label">Video Gallery</p>
                  </div>
                }
                {viewBooth.documents.length > 0 && 
                  <div className="booth-menu-item" onClick={handleDownload}>
                    <img src={pdf} className="booth-menu-item-icon" alt="resource-icon"/>
                    <p className="booth-menu-item-label">PDF Gallery</p>
                  </div>
                }
                {viewBooth.wallpaper_gallery.length > 0 &&
                  <div className="booth-menu-item" onClick={()=>handlePoster("wallpaper")}>
                    <svg width="24" height="24" viewBox="0 0 45.448 45.448">
                      <path d="M0,0H45.448V45.448H0Z" fill="none"/>
                      <path d="M37.086,33.3V6.787A3.8,3.8,0,0,0,33.3,3H6.787A3.8,3.8,0,0,0,3,6.787V33.3a3.8,3.8,0,0,0,3.787,3.787H33.3A3.8,3.8,0,0,0,37.086,33.3ZM14.173,23.793l3.977,4.791,5.87-7.556a.951.951,0,0,1,1.515.019l6.647,8.862a.946.946,0,0,1-.757,1.515H8.719A.943.943,0,0,1,7.98,29.89L12.7,23.83A.934.934,0,0,1,14.173,23.793Z" transform="translate(2.681 2.681)" fill="#fff"/>
                    </svg>
                    <p className="booth-menu-item-label">Image Gallery</p>
                  </div>
                }
                {/* <div className="booth-menu-item" onClick={openTawk}>
                  <img src={message} className="booth-menu-item-icon" alt="chat-icon" />
                  <p className="booth-menu-item-label">Talk <br/>To Us</p>
                </div> */}
              </div>
            </div>
          ) : (
            <div className="load-container">
              <LoadIcon />
            </div>
          )}
        </div>
        <VideoModal videos={isCustom ? viewBooth.booth_videos.slice(2, 4) :  boothId == 1 ? viewBooth.booth_videos.slice(0,2) : viewBooth.booth_videos} setVideoOpen={setVideoOpen} videoOpen={videoOpen} handleModal={handleModal} />
        {iframeOpen &&  <IframeModal iframeOpen={iframeOpen} setIframeOpen={setIframeOpen} iframe={playVideo} />}
        <DownloadModal setDocumentSelected={setDocumentSelected} files={viewBooth.documents} setDownloadOpen={setDownloadOpen} downloadOpen={downloadOpen} />
        <PosterModal images={viewBooth.wallpaper_gallery} posterOpen={posterOpen} setPosterOpen={setPosterOpen} />
        {documentSelected && <DocumentViewer file={documentSelected} setDocumentSelected={setDocumentSelected} />}
        <TawkModal embedId={EMBED_DIV_ID} tawkOpen={tawkOpen} setTawkOpen={setTawkOpen}/>  
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: #000;
  color: #FFF;
  height: 100%;
  padding-bottom: 100px;
  width: 100vw;
  overflow-y: scroll;
  position: absolute;

  .container {
    width: 90%;
  }
  .navCon {
    background: #2C3333;
  }
  .nav-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .booth-name {
    width: 70%;
    font-size: 16px;
    margin: 0;
  }
  .booth-image-wrapper {
    background-image: url(${fixedAssets.boothBg});
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 200px;
    position: relative;
  }
  .booth-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0;
    animation: appear 500ms 500ms forwards;
  }
  .booth-base {
    position: absolute;
    width: 100%;
    object-fit: contain;
    inset: 0; 
    top: 50%;
    animation: slideIn 800ms 800ms forwards;
  }
  .booth-material-container {
    min-height: 200px;
    background: #000;
    position: relative;
  }
  .divider {
    margin-top: 20px;
    background: #44ABE2;
    height: 3px;
  }
  .booth-menu-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin: 0;
    padding-top: 20px;
    position: relative;
  }
  .booth-menu-item {
    height: 60px;
    width: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .booth-menu-item-icon {
    height: 25px;
    filter: brightness(100);
  }
  .nav-buttons-wrapper {
    width: 50px;
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .nav-button-icon {
    height: 20px;
  }
  .booth-menu-item-label {
    font-size: 10px;
    color: #fff;
    margin: 0;
    text-align: center;
  }
  @keyframes slideIn {
    to { top: 0; }
  }
  #boothKv {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 20%;
    transition: all 500ms ease-in;
    animation: floating 5s infinite linear;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }

    .booth-image-wrapper {
      height: 300px;
    }
  }
`

export default MobileBooth
